import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { NotificationProvider } from './context/NotificationContext';
import { SelectedFormProvider } from './context/SelectedFormContext';

const root = createRoot(document.getElementById('mount'));
root.render(
	<React.StrictMode>
		<NotificationProvider>
			<SelectedFormProvider>
				<App />
			</SelectedFormProvider>
		</NotificationProvider>
	</React.StrictMode>
);
